import * as Phaser from 'phaser';
import { paintBoatSvg, type BoatDocument } from '../../sim/boat/index.ts';

const BOAT_SVG_URL = 'assets/svg/boat.svg';

let svgSource: Promise<string | null> | null = null;

export function loadBoatSvgSource(): Promise<string | null> {
  if (!svgSource) {
    svgSource = fetch(BOAT_SVG_URL)
      .then((response) => (response.ok ? response.text() : null))
      .catch(() => null);
  }

  return svgSource;
}

/** Rasterize a painted hull into `key`. Returns null when the scene has already shut down. */
export function loadPaintedBoatTexture(
  scene: Phaser.Scene,
  sourceSvg: string,
  boat: Pick<BoatDocument, 'hull' | 'deck' | 'accent'>,
  key: string,
): Promise<string | null> {
  const svg = paintBoatSvg(sourceSvg, boat);
  const url = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml' }));

  return new Promise((resolve) => {
    const image = new Image();

    image.onload = () => {
      URL.revokeObjectURL(url);

      if (!scene.sys.isActive()) {
        resolve(null);
        return;
      }

      if (scene.textures.exists(key)) {
        scene.textures.remove(key);
      }

      scene.textures.addImage(key, image);
      resolve(key);
    };

    image.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(null);
    };

    image.src = url;
  });
}
